export default "__VITE_ASSET__DQiyohrA__"